import {useEffect, useState} from "react";

function getObserverOptions() {
  const mobile = window.matchMedia("(max-width: 768px)").matches;
  return {
    threshold: mobile ? 0.05 : 0.12,
    rootMargin: mobile ? "0px 0px 4% 0px" : "0px 0px -6% 0px"
  };
}

export default function useInView(ref, options = {}) {
  const {
    threshold = getObserverOptions().threshold,
    rootMargin = getObserverOptions().rootMargin,
    once = true
  } = options;
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return undefined;

    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      setInView(true);
      return undefined;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setInView(true);
          if (once) observer.disconnect();
        } else if (!once) {
          setInView(false);
        }
      },
      {threshold, rootMargin}
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, [ref, threshold, rootMargin, once]);

  return inView;
}
